(() => {
  const DESCRIPTION_SELECTORS = [
    '.appstleSelectedSellingPlanOptionDescription',
    '.appstle-frequency-description',
    '.appstle_subscription_description_text',
  ];

  const descriptionNeedsSanitize = (element) => {
    const html = element.innerHTML;
    if (!html.trim()) return false;

    if (/<\s*(style|meta|title|link|script)\b/i.test(html)) return true;
    if (/Cocoa HTML Writer/i.test(html)) return true;
    if (/p\.p\d*\s*\{/i.test(html)) return true;

    const text = element.textContent || '';
    return /p\.p\d*\s*\{/.test(text) || /Helvetica Neue/.test(text);
  };

  const extractDescriptionText = (html) => {
    if (!html || typeof html !== 'string') return '';

    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    if (!container) return '';

    container.querySelectorAll('style, meta, title, link, script').forEach((node) => node.remove());

    const paragraphs = Array.from(container.querySelectorAll('p'))
      .map((paragraph) => paragraph.textContent.replace(/\s+/g, ' ').trim())
      .filter((text) => text && !/^\s*p\.p\d*\s*\{/.test(text) && !/Helvetica Neue/.test(text));

    let text = paragraphs.join(' ').trim();

    if (!text) {
      text = (container.textContent || '')
        .replace(/\bp\.p\d*\s*\{[^}]*\}/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    return text.replace(/\bp\.p\d*\s*\{[^}]*\}/gi, '').replace(/\s+/g, ' ').trim();
  };

  const sanitizeDescriptionElement = (element) => {
    if (!element || !descriptionNeedsSanitize(element)) return;

    const cleanText = extractDescriptionText(element.innerHTML);
    if (!cleanText) return;

    element.replaceChildren();
    const paragraph = document.createElement('p');
    paragraph.textContent = cleanText;
    element.appendChild(paragraph);
  };

  const sanitizeAll = () => {
    const scopes = document.querySelectorAll('[data-subscription-widget-anchor], .appstle_sub_widget, [id^="appstle_subscription_widget"]');
    scopes.forEach((scope) => {
      DESCRIPTION_SELECTORS.forEach((selector) => {
        scope.querySelectorAll(selector).forEach(sanitizeDescriptionElement);
      });
    });
  };

  const scheduleSanitize = () => {
    window.requestAnimationFrame(sanitizeAll);
    window.setTimeout(sanitizeAll, 50);
    window.setTimeout(sanitizeAll, 200);
  };

  document.addEventListener('AppstleSubscription:SubscriptionWidget:widgetInitialised', scheduleSanitize);
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated', scheduleSanitize);
  document.addEventListener('AppstleSubscription:SubscriptionWidget:sellingPlanChanged', scheduleSanitize);
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', scheduleSanitize);

  if (window.jQuery) {
    window.jQuery(document).on('appstle_widget_updated', scheduleSanitize);
  }

  document.addEventListener(
    'change',
    (event) => {
      if (event.target?.closest?.('.appstle_select, .appstle_custom_select, select[name="selling_plan"]')) {
        scheduleSanitize();
      }
    },
    true
  );

  if (window.MutationObserver) {
    const observer = new MutationObserver(scheduleSanitize);
    document.querySelectorAll('[data-subscription-widget-anchor]').forEach((anchor) => {
      observer.observe(anchor, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSanitize);
  } else {
    scheduleSanitize();
  }
})();
